// @flow
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import MuiThemeProvider from "@material-ui/core/styles/MuiThemeProvider";
import Hidden from "@material-ui/core/Hidden";
import Typography from "@material-ui/core/Typography";

import Properties from "../../Properties.js";
import { LightTheme } from "../../global/types/themes";
import Display from "../component/Display";
import MobileDisplay from "../containers/MobileDisplay";
import type {
  TemplateStatesType,
  UserFormPropsType,
} from "../types/UserFormType";
import ErrorPage from "./ErrorPage";
import Signup from "./Signup";
import { getConferenceId } from "../../global/actions/databaseActions";
import LoadingProgress from "../../global/components/LoadingProgress";
import { ColorSchema } from "../../global/types/scss";
import ClosedBanner from "../../global/components/ClosedBanner";

class Template extends React.Component<UserFormPropsType, TemplateStatesType> {
  getConference: Function;
  constructor(props: UserFormPropsType) {
    super(props);
    this.state = {
      conference: props.params.conference || "",
      title: null,
      heading: "FaceTag Face Recognition",
      img: "",
      expired: false,
    };
    this.getConference = this.getConference.bind(this);
  }

  componentDidMount() {
    this.props.actions.getConferenceId(
      this.state.conference,
      this.getConference
    );
  }

  getConference(
    title: string,
    heading: string,
    hasLogo: boolean,
    id: string,
    expired: boolean
  ) {
    this.setState({ title: title });
    if (heading && heading !== "") {
      this.setState({ heading: heading });
    }
    if (hasLogo) {
      this.setState({
        img: `${Properties.api_root}/api/v2/conferences/${id}/logo`,
      });
    }
    if (expired) {
      this.setState({ expired: expired });
    }
  }

  render(): React$Element<*> | null {
    const title = this.state.title;
    let children = this.props.children || <Signup params={this.props.params} />;
    if (this.state.expired) {
      children = <ClosedBanner />;
    }
    if (title === null) {
      return <LoadingProgress size={100} />;
    } else if (title === "") {
      return <ErrorPage isLoaded={true} />;
    } else {
      return (
        <MuiThemeProvider theme={LightTheme}>
          <div className="mui-form">
            <Hidden smDown>
              <Display />
            </Hidden>
            <div className="right-wrapper">
              <Hidden mdUp>
                <MobileDisplay />
              </Hidden>
              <div
                className="inner-wrapper"
                style={
                  this.props.location.pathname.indexOf("admin") > -1
                    ? { maxWidth: "800px" }
                    : {}
                }
              >
                {this.state.img !== "" && (
                  <img src={this.state.img} className="site-logo" />
                )}
                <Typography
                  variant="headline"
                  className="form-text main-header"
                  style={{ color: ColorSchema("primary") }}
                >
                  <b>{title}</b>
                  <br />
                  {this.state.heading}
                </Typography>
                {children}
                <img
                  src="/images/poweredByVixVizion.svg"
                  className="company-logo"
                />
              </div>
            </div>
          </div>
        </MuiThemeProvider>
      );
    }
  }
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators({ getConferenceId }, dispatch) };
}

export default connect(null, mapDispatchToProps)(Template);



// WEBPACK FOOTER //
// ./src/conference/views/Template.js